// extracted by mini-css-extract-plugin
export var popover = "R_dr";
export var body = "R_dV";
export var notificationList = "R_dW";
export var btnFooter = "R_dX";
export var rotate = "R_c";
export var dotty = "R_d";